import { CssType } from 'src/theme/jss-types';

export const UserManagementStyles = (): CssType => ({
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    padding: 24,
  },
  actionsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  searchInput: {
    width: 200,
  },
  searchRow: {
    display: 'flex',
    alignItems: 'center',
    '& button': {
      marginLeft: 8,
      padding: 0,
    },
  },
  paginationRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
  },
  selectWithoutBorder: {
    marginLeft: 16,
  },
});
